import { useParams, useNavigate } from 'react-router-dom';
import { useTournament } from '../context/TournamentContext';
import { GameScorecard } from '../components/GameScorecard';
import { StatusBadge } from '../components/LiveIndicator';
import { calculateGameResult } from '../engine/scoring';
import { ArrowLeft } from 'lucide-react';
import type { TeamSide } from '../data/types';

export function GameScorecardPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { getGame, getMatchUp, getTeam, getScoresByGame, upsertScore } = useTournament();

  const game = id ? getGame(id) : undefined;
  if (!game) {
    return <div className="empty-state"><p>Hra nenalezena</p></div>;
  }

  const matchUp = getMatchUp(game.match_up_id);
  const teamA = matchUp?.team_a_id ? getTeam(matchUp.team_a_id) : null;
  const teamB = matchUp?.team_b_id ? getTeam(matchUp.team_b_id) : null;

  const gameLabel = game.type === 'foursome' ? 'Foursome' : `Single ${game.game_number}`;

  function handleScoreChange(holeNumber: number, teamSide: TeamSide, strokes: number) {
    upsertScore(game!.id, holeNumber, teamSide, strokes);
  }

  return (
    <div>
      <button className="btn btn-ghost mb-md" onClick={() => navigate(-1)}>
        <ArrowLeft size={16} /> Zpět
      </button>

      <div className="card mb-md" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>
          {matchUp?.label}
        </div>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '0.25rem' }}>{gameLabel}</h2>
        <div className="flex items-center gap-sm" style={{ justifyContent: 'center' }}>
          <span style={{ color: teamA?.color }}>{teamA?.name ?? 'TBD'}</span>
          <span className="text-muted">vs</span>
          <span style={{ color: teamB?.color }}>{teamB?.name ?? 'TBD'}</span>
        </div>
        <div className="mt-sm">
          {(() => {
            const scores = getScoresByGame(game.id);
            const gameResult = calculateGameResult(game, scores);
            if (gameResult.matchPlayState.isFinished) return <StatusBadge status="completed" />;
            if (scores.length > 0) return <StatusBadge status="in_progress" />;
            return <StatusBadge status="scheduled" />;
          })()}
        </div>
      </div>

      <div className="card">
        <GameScorecard game={game} onScoreChange={handleScoreChange} />
      </div>
    </div>
  );
}
